export const CareNet = 'CareNet'
export const SystemName = 'Multi Data'
